/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AllegatoFromJSON, ComuneDtoFromJSON, ProvinceDtoFromJSON, } from '../models';
/**
 *
 */
export class OnboardingApi extends runtime.BaseAPI {
    /**
     */
    elencoProvinceRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/common/listaProvince`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProvinceDtoFromJSON));
        });
    }
    /**
     */
    elencoProvince(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.elencoProvinceRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    elencoProvince1Raw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/bo/v1/common/listaProvince`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProvinceDtoFromJSON));
        });
    }
    /**
     */
    elencoProvince1(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.elencoProvince1Raw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    handleFileUploadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling handleFileUpload.');
            }
            if (requestParameters.idTipoAllegato === null || requestParameters.idTipoAllegato === undefined) {
                throw new runtime.RequiredError('idTipoAllegato', 'Required parameter requestParameters.idTipoAllegato was null or undefined when calling handleFileUpload.');
            }
            if (requestParameters.idTipoDocumento === null || requestParameters.idTipoDocumento === undefined) {
                throw new runtime.RequiredError('idTipoDocumento', 'Required parameter requestParameters.idTipoDocumento was null or undefined when calling handleFileUpload.');
            }
            if (requestParameters.filename === null || requestParameters.filename === undefined) {
                throw new runtime.RequiredError('filename', 'Required parameter requestParameters.filename was null or undefined when calling handleFileUpload.');
            }
            if (requestParameters.file === null || requestParameters.file === undefined) {
                throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling handleFileUpload.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.idAllegato !== undefined) {
                queryParameters['idAllegato'] = requestParameters.idAllegato;
            }
            if (requestParameters.idTipoAllegato !== undefined) {
                queryParameters['idTipoAllegato'] = requestParameters.idTipoAllegato;
            }
            if (requestParameters.idTipoDocumento !== undefined) {
                queryParameters['idTipoDocumento'] = requestParameters.idTipoDocumento;
            }
            if (requestParameters.idSoggetto !== undefined) {
                queryParameters['idSoggetto'] = requestParameters.idSoggetto;
            }
            if (requestParameters.filename !== undefined) {
                queryParameters['filename'] = requestParameters.filename;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/bo/v1/common/uploadDocument`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AllegatoFromJSON(jsonValue));
        });
    }
    /**
     */
    handleFileUpload(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.handleFileUploadRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    handleFileUpload1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling handleFileUpload1.');
            }
            if (requestParameters.idTipoAllegato === null || requestParameters.idTipoAllegato === undefined) {
                throw new runtime.RequiredError('idTipoAllegato', 'Required parameter requestParameters.idTipoAllegato was null or undefined when calling handleFileUpload1.');
            }
            if (requestParameters.idTipoDocumento === null || requestParameters.idTipoDocumento === undefined) {
                throw new runtime.RequiredError('idTipoDocumento', 'Required parameter requestParameters.idTipoDocumento was null or undefined when calling handleFileUpload1.');
            }
            if (requestParameters.filename === null || requestParameters.filename === undefined) {
                throw new runtime.RequiredError('filename', 'Required parameter requestParameters.filename was null or undefined when calling handleFileUpload1.');
            }
            if (requestParameters.file === null || requestParameters.file === undefined) {
                throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling handleFileUpload1.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.idAllegato !== undefined) {
                queryParameters['idAllegato'] = requestParameters.idAllegato;
            }
            if (requestParameters.idTipoAllegato !== undefined) {
                queryParameters['idTipoAllegato'] = requestParameters.idTipoAllegato;
            }
            if (requestParameters.idTipoDocumento !== undefined) {
                queryParameters['idTipoDocumento'] = requestParameters.idTipoDocumento;
            }
            if (requestParameters.idSoggetto !== undefined) {
                queryParameters['idSoggetto'] = requestParameters.idSoggetto;
            }
            if (requestParameters.filename !== undefined) {
                queryParameters['filename'] = requestParameters.filename;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/v1/common/uploadDocument`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AllegatoFromJSON(jsonValue));
        });
    }
    /**
     */
    handleFileUpload1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.handleFileUpload1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    handleMultipleFileUploadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.files === null || requestParameters.files === undefined) {
                throw new runtime.RequiredError('files', 'Required parameter requestParameters.files was null or undefined when calling handleMultipleFileUpload.');
            }
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling handleMultipleFileUpload.');
            }
            if (requestParameters.idTipiAllegato === null || requestParameters.idTipiAllegato === undefined) {
                throw new runtime.RequiredError('idTipiAllegato', 'Required parameter requestParameters.idTipiAllegato was null or undefined when calling handleMultipleFileUpload.');
            }
            if (requestParameters.idTipiDocumento === null || requestParameters.idTipiDocumento === undefined) {
                throw new runtime.RequiredError('idTipiDocumento', 'Required parameter requestParameters.idTipiDocumento was null or undefined when calling handleMultipleFileUpload.');
            }
            if (requestParameters.filenames === null || requestParameters.filenames === undefined) {
                throw new runtime.RequiredError('filenames', 'Required parameter requestParameters.filenames was null or undefined when calling handleMultipleFileUpload.');
            }
            const queryParameters = {};
            if (requestParameters.files) {
                queryParameters['files'] = requestParameters.files;
            }
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.idAllegati) {
                queryParameters['idAllegati'] = requestParameters.idAllegati;
            }
            if (requestParameters.idTipiAllegato) {
                queryParameters['idTipiAllegato'] = requestParameters.idTipiAllegato;
            }
            if (requestParameters.idTipiDocumento) {
                queryParameters['idTipiDocumento'] = requestParameters.idTipiDocumento;
            }
            if (requestParameters.idSoggetto !== undefined) {
                queryParameters['idSoggetto'] = requestParameters.idSoggetto;
            }
            if (requestParameters.filenames) {
                queryParameters['filenames'] = requestParameters.filenames;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/bo/v1/common/uploadDocuments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AllegatoFromJSON));
        });
    }
    /**
     */
    handleMultipleFileUpload(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.handleMultipleFileUploadRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    handleMultipleFileUpload1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.files === null || requestParameters.files === undefined) {
                throw new runtime.RequiredError('files', 'Required parameter requestParameters.files was null or undefined when calling handleMultipleFileUpload1.');
            }
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling handleMultipleFileUpload1.');
            }
            if (requestParameters.idTipiAllegato === null || requestParameters.idTipiAllegato === undefined) {
                throw new runtime.RequiredError('idTipiAllegato', 'Required parameter requestParameters.idTipiAllegato was null or undefined when calling handleMultipleFileUpload1.');
            }
            if (requestParameters.idTipiDocumento === null || requestParameters.idTipiDocumento === undefined) {
                throw new runtime.RequiredError('idTipiDocumento', 'Required parameter requestParameters.idTipiDocumento was null or undefined when calling handleMultipleFileUpload1.');
            }
            if (requestParameters.filenames === null || requestParameters.filenames === undefined) {
                throw new runtime.RequiredError('filenames', 'Required parameter requestParameters.filenames was null or undefined when calling handleMultipleFileUpload1.');
            }
            const queryParameters = {};
            if (requestParameters.files) {
                queryParameters['files'] = requestParameters.files;
            }
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.idAllegati) {
                queryParameters['idAllegati'] = requestParameters.idAllegati;
            }
            if (requestParameters.idTipiAllegato) {
                queryParameters['idTipiAllegato'] = requestParameters.idTipiAllegato;
            }
            if (requestParameters.idTipiDocumento) {
                queryParameters['idTipiDocumento'] = requestParameters.idTipiDocumento;
            }
            if (requestParameters.idSoggetto !== undefined) {
                queryParameters['idSoggetto'] = requestParameters.idSoggetto;
            }
            if (requestParameters.filenames) {
                queryParameters['filenames'] = requestParameters.filenames;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/common/uploadDocuments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AllegatoFromJSON));
        });
    }
    /**
     */
    handleMultipleFileUpload1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.handleMultipleFileUpload1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    helloRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/bo/v1/common/alive`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    hello(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.helloRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    hello1Raw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/common/alive`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    hello1(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.hello1Raw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    listaComuniByProvinciaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.provincia === null || requestParameters.provincia === undefined) {
                throw new runtime.RequiredError('provincia', 'Required parameter requestParameters.provincia was null or undefined when calling listaComuniByProvincia.');
            }
            const queryParameters = {};
            if (requestParameters.provincia !== undefined) {
                queryParameters['provincia'] = requestParameters.provincia;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/bo/v1/common/listaComuni`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ComuneDtoFromJSON));
        });
    }
    /**
     */
    listaComuniByProvincia(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listaComuniByProvinciaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    listaComuniByProvincia1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.provincia === null || requestParameters.provincia === undefined) {
                throw new runtime.RequiredError('provincia', 'Required parameter requestParameters.provincia was null or undefined when calling listaComuniByProvincia1.');
            }
            const queryParameters = {};
            if (requestParameters.provincia !== undefined) {
                queryParameters['provincia'] = requestParameters.provincia;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/common/listaComuni`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ComuneDtoFromJSON));
        });
    }
    /**
     */
    listaComuniByProvincia1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listaComuniByProvincia1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
